import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { dateTime } from '@guestgoodie/helpers'
import { useLingui } from '@lingui/react/macro'

function useTimeRange(order: GraphQL.OrderFragmentFragment) {
  return useMemo(() => {
    if (order.__typename === 'OrderDefault') {
      const service = order.default

      if (service.start && service.duration)
        return [
          dateTime.toRange({
            isoDateTime: service.start,
            duration: service.duration
          })
        ]

      if (service.guestDateRanges && service.guestDateRanges.length > 0) {
        return service.guestDateRanges.map(({ start, duration }) =>
          dateTime.toRange({
            isoDateTime: start,
            duration
          })
        )
      }
    }

    if (order.__typename === 'OrderEvent') {
      const event = order.event

      const duration =
        new Date(event.eventOccurence.endAt).getTime() -
        new Date(event.eventOccurence.startAt).getTime()

      return [
        dateTime.toRange({
          isoDateTime: event.eventOccurence.startAt,
          duration
        })
      ]
    }

    return []
  }, [order])
}

export function RequestTimes({
  order,
  goodie
}: {
  order: GraphQL.OrderFragmentFragment
  goodie: GraphQL.GoodieFragmentFragment
}) {
  const { t } = useLingui()
  const times = useTimeRange(order)

  const isBookWithSuggestions =
    goodie.__typename === 'Default' && goodie.default.bookWithSuggestions

  return (
    <div className="flex flex-col gap-1">
      <span className="text-regular text-text">
        {isBookWithSuggestions ? t`Possible times for the guest` : t`Time`}:
      </span>
      {times.map(function (text, index) {
        return (
          <span
            key={index}
            className="text-regular font-normal text-text-light"
          >
            {text}
          </span>
        )
      })}
    </div>
  )
}
